import React from 'react';

const About = React.forwardRef((props, ref) => (
  <section 
    id="about" 
    ref={ref} 
    data-animate="slide"
    className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-20 px-8"
  >
    <div className="container mx-auto flex flex-col lg:flex-row items-center gap-16">
      <div className="lg:w-1/2">
        <h2 className="text-4xl font-bold mb-8 text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-blue-600">
          Professional Profile
        </h2>
        <p className="text-lg mb-6 text-gray-700 leading-relaxed">
          Full-Stack Developer with <span className="font-bold text-purple-600">3.5 years of experience</span> at OSB Group. 
          Proficient in <span className="font-bold text-blue-600">Umbraco, C#, .NET</span>, and front-end technologies.
        </p>
        <p className="text-lg mb-6 text-gray-700 leading-relaxed">
          Expertise in <span className="font-bold text-purple-600">CI/CD processes</span> with TeamCity and Git. 
          Led the development of responsive marketing websites, integrating secure backend services.
        </p>

        <h3 className="text-2xl font-bold mt-12 mb-6 text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
          Education
        </h3>
        <div className="space-y-6">
          <div>
            <h4 className="font-bold text-gray-800">PDip Engineering Management</h4>
            <p className="text-gray-600">University of Leeds - March 2023</p>
          </div>
          <div>
            <h4 className="font-bold text-gray-800">Software Development Bootcamp</h4>
            <p className="text-gray-600">QA Limited - January 2022</p>
          </div>
          <div>
            <h4 className="font-bold text-gray-800">BEng Chemical Engineering with Hons</h4>
            <p className="text-gray-600">Aston University - September 2018</p>
          </div>
        </div>

        <div className="flex flex-wrap gap-4 mt-8">
          <span className="px-4 py-2 bg-blue-100 text-blue-800 rounded-full font-medium">Umbraco</span>
          <span className="px-4 py-2 bg-purple-100 text-purple-800 rounded-full font-medium">.NET</span>
          <span className="px-4 py-2 bg-indigo-100 text-indigo-800 rounded-full font-medium">C#</span>
          <span className="px-4 py-2 bg-green-100 text-green-800 rounded-full font-medium">TeamCity</span>
          <span className="px-4 py-2 bg-red-100 text-red-800 rounded-full font-medium">Git</span>
        </div>
      </div>
      <div className="lg:w-1/2 relative">
        <img 
          src="/images/about.jpeg" 
          alt="About Joseph Drozd" 
          className="w-full h-80 object-cover rounded-3xl shadow-2xl"
        />
        <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-yellow-400 rounded-full mix-blend-multiply opacity-70 animate-bounce"></div>
        <div className="absolute -top-6 -left-6 w-24 h-24 bg-pink-400 rounded-full mix-blend-multiply opacity-70 animate-pulse"></div>
      </div>
    </div>
  </section>
));

export default About;
